<template lang="pug">
  v-form(class="organizations-users-add")
    h2(
      v-if="!xsDevice"
      class="title-32px bold mb-2"
    ) {{ $t('New users') }}
    p(
      v-if="!xsDevice"
      class="text-14px light"
    ) {{ $t('Enter your colleagues` email and assign them a role, and we`ll send a message telling them what to do next. You can always change access in the settings section') }}
    ValidationObserver(ref="form")
      div(
        v-for="(user, idx) in users"
        :key="idx"
        class="organizations-users-add__item"
        :class="{ 'with-delete': users.length > 1 }"
      )
        ValidationProvider(
          :name="$t('Email')"
          rules="required|email"
          v-slot="{ errors }"
          mode="lazy"
        )
          v-text-field(
            v-model="users[idx].email"
            :label="$t('Email')"
            :error-messages="errors"
            filled
          )
        ValidationProvider(
          :name="$t('Role in system')"
          rules="required"
          v-slot="{ errors }"
          mode="lazy"
        )
          v-select(
            v-model="users[idx].role"
            :items="userRoles"
            :label="$t('Role in system')"
            :error-messages="errors"
            :menuProps="{ bottom: true, offsetY: true }"
            filled
          )
            template(v-slot:item="{ item }")
              div(class="d-flex justify-space-between w-100")
                span {{ item?.text }}
                v-tooltip(bottom)
                  template(v-slot:activator="{ on }")
                    e-svg-icon(v-on="on") info-circle
                  span {{ item?.tooltip }}
        v-btn(
          v-if="users && users.length > 1"
          class="organizations-users-add__item-delete"
          height="48"
          color="#FF17440F"
          @click="deleteUser(idx)"
        )
          e-svg-icon danger-trash
      div(class="d-flex align-center pb-8")
        v-switch(
          v-model="notifyUsers"
          class="mt-0 mr-2"
          hide-details
        )
        span(class="text-14px light dark pt-1") {{ $t('Send emails about documents') }}
    div(class="organizations-users-add__actions")
      v-btn(
        class="secondary-button"
        @click="addUser"
      ) {{ $t('Add one more user') }}
      v-btn(
        :loading="isLoading"
        class="main-button"
        @click="submit"
      ) {{ $t('Send messages') }}
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import OrganizationUsers from '~/modules/organizations/models/OrganizationUsers'
import responsive from '~/mixins/pages/responsive'
import ELink from '~/components/elements/links/e-link.vue'

export default {
  name: 'FormOrganizationsUsersAdd',
  components: {
    ValidationProvider,
    ELink
  },
  mixins: [responsive],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    closeDrawer: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      users: [
        {
          email: null,
          role: null
        }
      ],
      isLoading: false,
      notifyUsers: true
    }
  },
  computed: {
    userRoles() {
      return OrganizationUsers.userRoles.filter(
        item => item.value !== OrganizationUsers.ROLES.OWNER
      )
    }
  },
  methods: {
    addUser() {
      this.users.push({
        email: null,
        role: null
      })
    },
    deleteUser(userIdx) {
      this.users.splice(userIdx, 1)
    },
    closeWindow(value) {
      // todo: component does not depend on drawer or model
      if (this.xsDevice) {
        this.closeDrawer(value)
      } else {
        this.closeModal(value)
      }
    },
    async submit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        return
      }
      try {
        this.isLoading = true
        for (const { email, role } of this.users) {
          const payload = {
            email,
            role,
            organizationId: this.$route.params.id,
            notifyIncoming: role === OrganizationUsers.ROLES.ACCOUNTANT ? false : this.notifyUsers,
            notifySigned: this.notifyUsers,
            notifyApproved: this.notifyUsers,
            notifyRejected: this.notifyUsers,
            notifyComments: this.notifyUsers,
            notifyReminders: this.notifyUsers
          }
          await this.$store.dispatch('organizationusers/create', { payload })
        }
        this.closeWindow(true)
      } catch (e) {
        this.closeWindow(false)
        this.$handlers.error(e, this)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss">
.organizations-users-add {
  &__item {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    &.with-delete {
      grid-template-columns: 1fr 1fr 48px;
    }
  }
  &__actions {
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 16px;

    @media (min-width: map-get($breakpoints, 'md')) {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: none;
    }
  }
}
</style>
